import { action } from 'satcheljs';
import SmimeViewState from '../store/schema/SmimeViewState';

// Action called to set the current BCC recipient of the mail.
export default action(
    'setCurrentBccRecipient',
    (smimeViewState: SmimeViewState, currentBccRecipient: number) => ({
        smimeViewState,
        currentBccRecipient,
    })
);
